import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { msalConfig } from './config/authConfig';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'fontsource-roboto';
import reportWebVitals from './reportWebVitals';

export const pca = new PublicClientApplication(msalConfig);

const AppProvider = () => (
    <MsalProvider instance={pca}>
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>
    </MsalProvider>
);

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <AppProvider />,
    rootElement); //entry point for react app

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);